module.exports = __webpack_public_path__ + "src/images/measurements/outseam.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/outseam.jpg
// module id = 1156
// module chunks = 0